import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PspConfiguracaoEmpresa } from '../api/dto/psp-configuracao-empresa';

@Injectable({
  providedIn: 'root'
})
export class PspConfiguracaoEmpresaService {

  private url : string = UrlServidor.URL_BASE + 'psp-configuracao-empresa';

  constructor(private http: HttpClient) { }

  buscarPorId(pspConfigId?: number): Observable<PspConfiguracaoEmpresa> {
    return this.http.get<PspConfiguracaoEmpresa>(`${this.url}/${pspConfigId}`);
  }

  listarPorEmpresa(empresaId?: number): Observable<PspConfiguracaoEmpresa[]> {
    return this.http.get<PspConfiguracaoEmpresa[]>(`${this.url}/empresa/${empresaId}`);
  }

  salvar(pspConfigRequest?: PspConfiguracaoEmpresa): Observable<void> {
    return this.http.post<void>(this.url, pspConfigRequest);
  }

  excluir(pspIdConfigId: number):Observable<void> {
    return this.http.delete<void>(`${this.url}/${pspIdConfigId}`);
  }
}
